import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Breadcrumb from '@taglivros/oef_componentes/build/components/breadcrumb'
import Card from '@taglivros/oef_componentes/build/components/card'
import { array, func, number, string } from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const BreadcrumbWrapper = styled.div`
  margin: 0 auto;
  padding: 5px 30px;
  width: ${( { largura } ) => largura};

  ul {
    position: relative;

    &:after {
      max-width: 100%;
    }

    &:before {
      left: 0;
    }

    li {
      @media(min-width: ${StyleGuide.mediaQuery.mobile}) {
        width: ${( { itens } ) => itens && `calc( 100%/${itens})`};
      }
    }
  }
`

const BreadcrumbCardWrapper = styled.div`
  > div {
    padding: 15px 0;

    p {
      font-size: 14px;
    }
  }
`

const BreadcrumbCard = ( { ativo, largura, margin, onClick, passos } ) => {
  return (
    <BreadcrumbCardWrapper>
      <Card
        margin={ margin }
      >
        <BreadcrumbWrapper
          itens={ passos.length }
          largura={ largura }
        >
          <Breadcrumb
            ativo={ ativo }
            itens={ passos }
            onClick={ onClick }
          />
        </BreadcrumbWrapper>
      </Card>
    </BreadcrumbCardWrapper>
  )
}

BreadcrumbCard.propTypes = {
  'ativo': number,
  'largura': string,
  'margin': string,
  'onClick': func.isRequired,
  'passos': array
}

BreadcrumbCard.defaultProps = {
  'ativo': 1,
  'largura': '',
  'margin': '',
  'passos': []
}

export default BreadcrumbCard
